module.exports = __webpack_public_path__ + "assets/img/28_1057.b973f34a.jpg";